var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "card-body" }, [
        _c(
          "div",
          { staticClass: "flex justify-content-between" },
          [
            _c("div", { staticClass: "flex flex_gap_10" }, [
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Препарат")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.filter.d,
                      expression: "filter.d",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "text",
                    placeholder: "Наименование препарата",
                  },
                  domProps: { value: _vm.filter.d },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.filter, "d", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("label", { attrs: { for: "" } }, [_vm._v("Статус")]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filter.s,
                        expression: "filter.s",
                      },
                    ],
                    staticClass: "form-control",
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.$set(
                          _vm.filter,
                          "s",
                          $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        )
                      },
                    },
                  },
                  [
                    _c("option", { attrs: { value: "-1" } }, [
                      _vm._v("Все статусы"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.statuses, function (s, id) {
                      return _c("option", { domProps: { value: id } }, [
                        _vm._v(_vm._s(s.title)),
                      ])
                    }),
                  ],
                  2
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("LoadingButton", {
              attrs: {
                title: "Показать",
                loading: _vm.loading,
                color: _vm.$constants.PRIMARY_COLOR,
                onClick: () => _vm.getRecords(),
                className: "btn btn-outline-info",
              },
            }),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c("div", [
                _c("table", { staticClass: "table m-0 table-sm table-hover" }, [
                  _c(
                    "tbody",
                    _vm._l(_vm.records, function (r, i) {
                      return _c("tr", [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              i +
                                1 +
                                ((_vm.paginator?.current_page ?? 1) - 1) *
                                  (_vm.paginator?.per_page ?? 1)
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(r?.related_ms_drug?.title))]),
                        _vm._v(" "),
                        _c("td", [
                          r.task_data?.comment
                            ? _c("p", [_vm._v(_vm._s(r.task_data.comment))])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            _vm._l(
                              r.task_data?.report?.comments ?? [],
                              function (c, ii) {
                                return _c(
                                  "div",
                                  { class: { "border-top": ii > 0 } },
                                  [
                                    _c("p", [_vm._v(_vm._s(c.text))]),
                                    _vm._v(" "),
                                    _c(
                                      "p",
                                      { staticClass: "text-muted text-right" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.printDate(c.created_at))
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-info",
                              on: {
                                click: function ($event) {
                                  return _vm.mixinOpenDrawer({
                                    type: "drugTasks003",
                                    task: {
                                      ...r,
                                      task_data: { ...r.task_data },
                                    },
                                  })
                                },
                              },
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-eye" })]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("p", [
                            _c(
                              "span",
                              {
                                class: {
                                  badge: true,
                                  [_vm.statuses[r.status]?.class]: true,
                                },
                              },
                              [_vm._v(_vm._s(_vm.statuses[r.status]?.title))]
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.printDate(r.created_at, "DD.MM.YYYY"))
                            ),
                          ]),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-right" },
            [
              _vm.paginator
                ? _c("paginate", {
                    ref: "Pagination",
                    attrs: {
                      "page-count": _vm.paginator.last_page,
                      "page-range": 11,
                      "margin-pages": 2,
                      "click-handler": _vm.getRecords,
                      "prev-text": "&laquo",
                      "next-text": "&raquo",
                      "container-class": "pagination",
                      "prev-class": "page-item",
                      "prev-link-class": "page-link",
                      "page-class": "page-item",
                      "page-link-class": "page-link",
                      "next-class": "page-item",
                      "next-link-class": "page-link",
                      "active-class": "active green_btn",
                    },
                    model: {
                      value: _vm.paginator.current_page,
                      callback: function ($$v) {
                        _vm.$set(_vm.paginator, "current_page", $$v)
                      },
                      expression: "paginator.current_page",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }